(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["SPlayer"] = factory();
	else
		root["SPlayer"] = factory();
})(self, () => {
return 